import ReactECharts from "echarts-for-react";
import { cn } from "@/lib/utils";
import { AppPaymentChartProps } from "@/modules/finance/helper/types/app-payment-chart-props.type";

export const AppPaymentChart = ({ title, className, chartOptions }: AppPaymentChartProps) => {
  return (
    <div className={cn("flex-1 rounded-2xl border border-icon py-3 px-8 bg-white", className)}>
      <div className="mb-2">
        <span className="text-primary font-black text-xs">{title}</span>
      </div>
      <ReactECharts option={chartOptions} style={{ height: 147 }} />
    </div>
  );
};
